export function getFilterKeys(state) {
  return Object.keys(state).filter((key) => key.startsWith('filter_'));
}

export function isValidFilterValue(value) {
  return (
    (Array.isArray(value) && value.length > 0) ||
    (typeof value === 'string' && value.trim() !== '') ||
    typeof value === 'number'
  );
}

export function getCleanedFilterForm(form, skipFields = []) {
  if (!form) return {};

  return Object.entries(form)
    .filter(([field, value]) => {
      if (skipFields.includes(field)) return false;
      return isValidFilterValue(value);
    })
    .reduce((acc, [field, value]) => {
      acc[field] = value;
      return acc;
    }, {});
}

export function getActiveFiltersForSaving(state) {
  const activeFilters = {};

  const keys = getFilterKeys(state);

  keys.forEach((key) => {
    const form = state[key].form;
    const cleanedForm = getCleanedFilterForm(
      form,
      key === 'filter_address' ? ['city'] : []
    );
    if (Object.keys(cleanedForm).length > 0) {
      activeFilters[key] = { form: cleanedForm };
    }
  });

  return activeFilters;
}
